module.exports = __webpack_public_path__ + "static/media/favicon.5cc45a7f.png";